import * as React from "react"
export const ToolbarRotate = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
        height={20}
         viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g >
      <path
        fill="#6C757D"
        d="M18.277 10.73a8.359 8.359 0 1 1-2.366-6.563h-2.602a.833.833 0 0 0 0 1.666h3.453a1.548 1.548 0 0 0 1.547-1.547V.833a.833.833 0 1 0-1.667 0v1.732a9.987 9.987 0 1 0 3.292 8.352.841.841 0 0 0-.833-.917.818.818 0 0 0-.824.73Z"
      />
    </g>
  </svg>
)
